<template>
  <div class="page page--signup">
    <div class="section section--signup">
      <h2 class="section__title">Sign up</h2>
      <div class="section__container">
        <div class="section__content">
          <form @submit.prevent="submit">
            <label for="email">Poshmark Email</label>
            <input class="input" id="email" v-model="form.email" type="email" />
            <label for="username">Poshmark Username</label>
            <input class="input"  id="username" v-model="form.username" type="text" />
            <label for="password">Poshmark Password</label>
            <input class="input"  id="password" v-model="form.password" type="password" />
            <label>Credit Card</label>
            <StripeCard :stripeKey="stripeKey" @paymentMethod="setPaymentMethod" />
            <input class="control" type="submit" value="Sign up" />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StripeCard from '@/components/StripeCard.vue';

export default {
  components: {
    StripeCard,
  },
  data() {
    return {
      form: {
        username: '',
        email: '',
        password: '',
        paymentMethod: null,
      },
    };
  },
  computed: {
    stripeKey() {
      // TODO: replace with env value
      return 'pk_test_51HS4CrLaTrDAzoRWAAM4dsHGbz8Qq7gIGx3NBOt0oHYZh9yrGm04xnOhKZTrLW5r3mGoodWhvQIgIDVzgtriBLce00sCXpbFhY';
    },
  },
  methods: {
    setPaymentMethod(paymentMethod) {
      this.form.paymentMethod = paymentMethod.id;
    },
    submit() {
      this.$store.dispatch('signup', this.form);
    },
  },
};
</script>
